'use client'

import s from './AboutUs.module.scss';
import {Label} from "@/app/[locale]/common/components/Label/Label";
import {Line} from "@/app/[locale]/common/components/Line/Line";
import {CircleArrowIcon} from "@/app/[locale]/common/assets/CircleArrowIcon/CircleArrowIcon";
import image from '@/app/[locale]/common/assets/images/about-us/img_about_us.webp';
import Image from 'next/image';
import {ConfirmIcon} from "@/app/[locale]/common/assets/ConfirmIcon/ConfirmIcon";
import {APP_ROUTES} from "../../constants/app";
import {TextIconLink} from "@/app/[locale]/common/components/TextIconLink/TextIconLink";
import {useTranslations} from "next-intl";

export const AboutUs = () => {
    const t = useTranslations('MainPage.AboutBlock');

    return (
        <section className={s.about}>
            <div className={s.about_labelContainer}>
                <Label>{t('label')}</Label>
                <Line className={s.about_line} />
                <TextIconLink
                    href={APP_ROUTES.ABOUT_US}
                    icon={<CircleArrowIcon />}
                >
                    { t('textIconLink') }
                </TextIconLink>
            </div>

            <div className={s.about_contentContainer}>
                <div className={s.about_content}>
                    <p>{t('firstTextBlock')}</p>

                    <div className={s.about_content_card}>
                        <label>{t('contentCardLabel')}</label>

                        <ul className={s.about_content_card_list}>
                            {t.raw('expertiseList').map((item: string, index: number) => (
                                <li key={index} className={s.about_content_card_item}>
                                    <span><ConfirmIcon/></span>
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>

                    <p>{t('secondTextBlock')}</p>
                </div>
                <div className={s.about_imageContainer}>
                    <Image src={image} alt='about_image'/>
                </div>
                <TextIconLink
                    href={APP_ROUTES.ABOUT_US}
                    icon={<CircleArrowIcon />}
                >
                    { t('textIconLink') }
                </TextIconLink>
            </div>
        </section>
    );
};